// import * as firebase from "firebase/app"
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// Document Approval System
const firebaseConfig = {
  apiKey: "AIzaSyAnjQBuh4c2DX8RX8KC7uVgpERyc1mi3XA",
  authDomain: "document-approval-b8946.firebaseapp.com",
  projectId: "document-approval-b8946",
  storageBucket: "document-approval-b8946.firebasestorage.app",
  messagingSenderId: "518171744345",
  appId: "1:518171744345:web:b195f770ad70793e35b948",
  measurementId: "G-4RP5BJTR8Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const storage = getStorage(app);
const db = getFirestore(app);

// const uid = auth.currentUser?.uid;

export { db, auth, app, storage };
